import React from 'react';
import WaitlistForm from '../../components/marketing/WaitlistForm';
import { HEALTH_CHECK_COPY } from '../content/healthCheck';
import Button from '../primitives/Button';
import type { HcAction } from './healthCheckMachine';

interface HealthCheckCaptureProps {
  dispatch: React.Dispatch<HcAction>;
}

/**
 * Name, email and consent — the existing waitlist capture, in its panel
 * variant, tagged with the 'health_check' surface. Nothing the person
 * answered is passed to it; the questionnaire state stays in the provider.
 */
export default function HealthCheckCapture({ dispatch }: HealthCheckCaptureProps) {
  return (
    <>
      <p className="t-details">{HEALTH_CHECK_COPY.captureTitle}</p>
      <p className="mk-hc-panel__hint t-body">{HEALTH_CHECK_COPY.captureBody}</p>
      <WaitlistForm
        sourceSurface="health_check"
        variant="panel"
        submitLabel={HEALTH_CHECK_COPY.captureSubmit}
        onSuccess={(ref) => dispatch({ type: 'CAPTURED', ref })}
      />
      <div className="mk-hc-actions">
        <Button variant="link" onClick={() => dispatch({ type: 'BACK' })}>
          {HEALTH_CHECK_COPY.back}
        </Button>
      </div>
    </>
  );
}
